import { ensureTrailingSlash } from '@otovo/shared/components/BusinessUnitLogo';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import useMobileVersion from '@otovo/shared/lib/useMobileVersion';
import Link, { LinkProps } from 'next/link';
import OtovoLogo, { OtovoLogoSize, OtovoLogoVariant } from '../icons/Logo';

type Props = {
  variant?: OtovoLogoVariant;
  label?: string;
} & Omit<LinkProps, 'href'>;

type LogoConfig = {
  logoWidth: number;
  size: OtovoLogoSize;
};

const getLogoConfig = (isMobile: boolean): LogoConfig => {
  return {
    logoWidth: isMobile ? 50 : 120,
    size: isMobile ? 'small' : 'normal',
  };
};

const CompanyLink = ({ variant = 'blue', label, ...linkProps }: Props) => {
  const { STOREFRONT_URL } = useGlobalConfig();
  const isMobile = useMobileVersion(640);

  const { size, logoWidth } = getLogoConfig(isMobile);

  return (
    <Link href={ensureTrailingSlash(STOREFRONT_URL)} {...linkProps}>
      {label && <span className="sr-only">{label}</span>}
      <OtovoLogo
        variant={variant}
        width={logoWidth}
        height={isMobile ? '34px' : '44.5px'}
        size={size}
        aria-hidden="true"
        focusable="false"
      />
    </Link>
  );
};

export default CompanyLink;
